<template>
  <SchemaTablePage
    ref="tablePageRef"
    layout-mode="page"
    :search-schema="searchSchema"
    :columns="tableColumns"
    :default-query="defaultQuery"
    :request="request"
    :build-params="buildParams"
    :parse-result="parseResult"
  >
    <template #colMemberAccount="{ row }">
      <MemberAccountCell
        :row="row"
        :username="row.target_name"
        :uid="row.target_id"
        :vip-level="row.vip_level"
        default-detail-tab-type="memberLogs"
      />
    </template>
    <template #colBefore="{ row }">
      <el-popover placement="top" width="400" trigger="hover">
        <div style="white-space: pre-wrap">{{ row.before | formatChangeString }}</div>
        <div slot="reference" class="log-content">
          {{ row.before | formatChangeString }}
        </div>
      </el-popover>
    </template>
    <template #colAfter="{ row }">
      <el-popover placement="top" width="400" trigger="hover">
        <div style="white-space: pre-wrap">{{ row.after | formatChangeString }}</div>
        <div slot="reference" class="log-content">
          {{ row.after | formatChangeString }}
        </div>
      </el-popover>
    </template>
    <template #colCreatedAt="{ row }">{{ row.created_at | formatTimestamp }}</template>
  </SchemaTablePage>
</template>

<script>
// 引入mock数据
import { MemberApi } from '@/api/member/member'
import { formatCurrency } from '@/pages/common/utils'
import { formatTimestamp, toUnixSeconds } from '@/utils/time'
import MemberAccountCell from '@/components/MemberAccountCell.vue'
import SchemaTablePage from '@/components/SchemaTablePage'
export default {
  name: 'AdminMemberLog',
  components: { SchemaTablePage, MemberAccountCell },
  filters: {
    formatTimestamp,
    formatChangeString(str) {
      if (!str) {
        return ''
      }
      const numbers = str.match(/\d+(\.\d+)?/g)
      if (numbers && numbers.length > 0) {
        const amount = numbers[0]
        const amountCurrency = formatCurrency(amount)
        return str.replace(numbers[0], amountCurrency)
      }
      return str
    },
  },
  data() {
    return {
      defaultQuery: {
        memberNo: '',
        username: '',
        module: '',
        operationDateRange: [],
      },
      searchSchema: [
        { prop: 'memberNo', label: '会员账号', component: 'input', componentProps: { clearable: true } },
        { prop: 'username', label: '操作人', component: 'input', componentProps: { clearable: true } },
        {
          prop: 'operationDateRange',
          label: '操作时间',
          component: 'datetime-range',
          componentProps: { clearable: true },
          span: { xs: 24, sm: 12, md: 12, lg: 8, xl: 6, xxl: 6 },
        },
        { component: 'actions', span: { lg: 4 } },
      ],
      tableColumns: [
        { prop: 'id', label: '序号', width: 60, align: 'center', resizable: false },
        { prop: 'target_name', label: '会员账号', minWidth: 140, resizable: false, slot: 'colMemberAccount' },
        { prop: 'module', label: '操作菜单', minWidth: 200, resizable: false },
        { prop: 'server_desc', label: '操作内容', minWidth: 160, resizable: false },
        { prop: 'before', label: '修改前', minWidth: 140, resizable: false, slot: 'colBefore' },
        { prop: 'after', label: '修改后', minWidth: 140, resizable: false, slot: 'colAfter' },
        { prop: 'username', label: '操作人', width: 100, resizable: false },
        { prop: 'created_at', label: '最后操作时间', width: 140, resizable: false, slot: 'colCreatedAt' },
      ],
    }
  },
  methods: {
    request(params) {
      return MemberApi.getMemberLogList(params)
    },
    buildParams({ query, page, limit }) {
      const params = {
        page,
        page_size: limit,
        target_name: query?.memberNo || '',
        username: query?.username || '',
      }
      if (query?.operationDateRange && query.operationDateRange.length === 2) {
        params.start_at = toUnixSeconds(query.operationDateRange[0])
        params.end_at = toUnixSeconds(query.operationDateRange[1])
      }
      return params
    },
    parseResult(response) {
      return {
        list: response?.data?.list || [],
        total: response?.data?.total || 0,
      }
    },
  },
}
</script>

<style scoped>
.log-content {
  max-height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.pagination-container {
  margin-top: 15px;
  text-align: right;
}
</style>
